<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits } from 'vue';
import ListaAnexoBase from '@/components/v2/base/ListaAnexoBase/ListaAnexoBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: Array,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    },
    multiple: {
        type: Boolean,
        default: true
    }
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'change',
]);

/*==================================================================*/
/*================== MÉTODOS =======================================*/
/*==================================================================*/

const onChange = (event) => {

    emits('change', event);
    
};

</script>

<template>

    <div class="c-file-input">

        <v-file-input
            class="c-anexo-input"
            :label="props.label"
            :value="props.value"
            :disabled="props.disabled"
            :multiple="props.multiple"
            prepend-icon="mdi-paperclip"
            outlined
            hide-details
            @change="onChange($event)"
        ></v-file-input>

        <div class="c-lista-anexos">

            <ListaAnexoBase
                :value="props.value"
            ></ListaAnexoBase>

        </div>

    </div>

</template>

<style scoped>

.c-file-input{
    display: grid;
    width: 100%;
    grid-template-columns: 1fr;
    grid-auto-rows: max-content;
    gap: 5px;
}

.c-anexo-input {
    padding: 2px;
}

.c-anexo-input >>> .v-input__slot{
    min-height: 48px;
}

.c-lista-anexos{
    padding-left: 40px;
}

</style>
